<template>
  <div class="kpiListPage">

    <div class="content-header withgray">
      <i class="content-header-nav el-icon-arrow-left" @click="toBack"></i>
      市场风云
    </div>
    <!--      <div class="content-header" style="display:none">-->
    <!--        <el-radio-group v-model="teamTab" size="small">-->
    <!--          <el-radio-button label="Patrol">巡查</el-radio-button>-->
    <!--          <el-radio-button label="right">业务</el-radio-button>-->
    <!--        </el-radio-group>-->
    <!--      </div>-->

    <div class="content-body" style="margin-top: 50px;">
      <!-- <div class="regular">蒙牛-低温报表</div> -->
      <div class="box">
        <div class="box-header">
          <div class="rod"></div>
          <span class="title">现代</span>
        </div>
        <div class="box-body">
          <ul class="list-group">
            <li @click="viewDetail('ModernCoreDisplay','费用落地执行')">费用落地执行</li>
            <li @click="viewDetail('ModernMarketRate','品牌铺市率')">品牌铺市率</li>

            <li @click="viewDetail('ModernDayCD','[日龄]CD杯')">[日龄]CD杯</li>
            <li @click="viewDetail('ModernDayU','[日龄]100ML优益C')">[日龄]100ML优益C</li>

            <li @click="viewDetail('ModernDayGYR','[日龄]250冠益乳系列')">[日龄]250冠益乳系列</li>
            <li @click="viewDetail('ModernPromotionCD','[促销]CD杯')">[促销]CD杯</li>

            <li @click="viewDetail('ModernPromotionU','[促销]100ML优益C')">[促销]100ML优益C</li>
            <li @click="viewDetail('ModernPromotionGYR','[促销]250冠益乳系列')">[促销]250冠益乳系列</li>
            <li @click="viewDetail('ModernPromotionRate','冷风柜资源占有率')">冷风柜资源占有率</li>

            <!-- <li @click="viewDetail('ModernPromotionExecute','常规促销执行情况')">常规促销执行情况</li> -->
            <li @click="viewDetail('TwentyNew','小U铺市率')">小U铺市率</li>
            <li @click="viewDetail('EightyAvgGoods','250冠益乳铺市率')">250冠益乳铺市率</li>
            <li @click="viewDetail('TwentyStock','0糖系列铺市率')">0糖系列铺市率</li>
            <!-- <li style="background-color: #fff;"></li> -->
          </ul>
        </div>
      </div>
      <div class="box">
        <div class="box-header">
          <div class="rod"></div>
          <span class="title">全店通</span>
        </div>
        <div class="box-body">
          <ul class="list-group">
            
            <li @click="viewDetail('AllStock','品牌铺市率')">品牌铺市率</li>
            
            <li @click="viewDetail('AllDisplay','第一陈列率')">第一陈列率</li>
            
            <li @click="viewDetail('MAAvgGoods','小U铺市率')">小U铺市率</li>
            <li @click="viewDetail('EightyGoods','250冠益乳铺市率')">250冠益乳铺市率</li>
            <li @click="viewDetail('MANew','0糖系列铺市率')">0糖系列铺市率</li>
            <li style="background-color: #fff;"></li>
          </ul>
        </div>
      </div>
      <div class="box">
        <div class="box-header">
          <div class="rod"></div>
          <span class="title">自投柜渠道</span>
        </div>
        <div class="box-body">
          <ul class="list-group">
            
            <li @click="viewDetail('TwentyBox','自投柜使用')">MN自投柜使用</li>
            
            <li @click="viewDetail('TwentyAvgGoods','行业自投柜使用')">行业自投柜使用</li>
          </ul>
        </div>
      </div>
      <!-- <div class="box">
        <div class="box-header">
          <div class="rod"></div>
          <span class="title">MA</span>
        </div>
        <div class="box-body">
          <ul class="list-group">
            
            <li @click="viewDetail('EightyGoods','自投柜使用')">自投柜使用</li>
            <li @click="viewDetail('MADisplay','第一陈列率')">第一陈列率</li>
            <li @click="viewDetail('MAAvgGoods','囤货统计')">囤货统计</li>
          </ul>
        </div>
      </div> -->
      <div class="box">
        <div class="box-header">
          <div class="rod"></div>
          <span class="title">CVS</span>
        </div>
        <div class="box-body">
          <ul class="list-group">
            <li @click="viewDetail('CVSStock','品牌铺市率')">品牌铺市率</li>
            <li @click="viewDetail('CVSDisplay','第一陈列率')">第一陈列率</li>
            <li @click="viewDetail('CVSAvg','小U铺市率')">小U铺市率</li>
            <li @click="viewDetail('CVSFreezer','250冠益乳铺市率')">250冠益乳铺市率</li>
            <li @click="viewDetail('MADisplay','0糖系列铺市率')">0糖系列铺市率</li>
            <li style="background-color: #fff;"></li>
          </ul>
        </div>
      </div>
    </div>


  </div>
</template>
<script>

export default {
  data() {
    return {
      teamTab: 'Patrol',
      uid: 0,
    };
  },
  mounted() {
    this.uid = this.$route.params.uid;
  },
  methods: {
    viewDetail(module, title) {
      console.log(module, title, this.uid + "/" + module + "/" + title);
      switch (module) {
        case 'ModernCoreDisplay':// 1、现代 - 核心陈列
          this.$router.push({path: "/ModernCoreDisplay/" + this.uid + "/" + module + "/" + title});
          break;

        case 'ModernMarketRate':// 2、 现代 - 铺市率
          this.$router.push({path: "/ModernMarketRate/" + this.uid + "/" + module + "/" + title});
          //this.$router.push({path: "/ModernStack/" + this.uid + "/" + 'ModernStack' + "/" + title});
          break;

        case 'ModernDayCD':// 3、 现代-[日龄]CD杯
          this.$router.push({path: "/ModernDayCD/" + this.uid + "/" + module + "/" + title});
          break;

        case 'ModernDayU':// 4、现代-[日龄]100ML优益C
          this.$router.push({path: "/ModernDayU/" + this.uid + "/" + module + "/" + title});
          break;

        case 'ModernDayGYR': // 5、 [日龄]250冠益乳系列
          this.$router.push({path: "/ModernDayGYR/" + this.uid + "/" + module + "/" + title});
          break;

        case 'ModernPromotionCD': // 6、 现代-[促销]CD杯
          this.$router.push({path: "/ModernPromotionCD/" + this.uid + "/" + 'ModernPSour' + "/" + title});
          //this.$router.push({path: "/ModernPromotion/" + this.uid + "/" + 'ModernPSour' + "/" + title});
          break;
        case 'ModernPromotionU': // 7、 [促销]100ML优益C
          this.$router.push({path: "/ModernPromotionU/" + this.uid + "/" + module + "/" + title});
          break;
        case 'ModernPromotionGYR': // 8、 现代-[促销]250冠益乳系列
          this.$router.push({path: "/ModernPromotionGYR/" + this.uid + "/" + module + "/" + title});
          break;

        case 'ModernPromotionExecute': // 9、 现代-常规促销执行情况
          this.$router.push({path: "/ModernPromotionExecute/" + this.uid + "/" + module + "/" + title});
          break;
        case 'ModernPromotionRate': // 10、 现代-冷风柜资源占有率
          this.$router.push({path: "/ModernPromotionRate/" + this.uid + "/" + module + "/" + title});
          break;


        case 'ModernStack':
          this.$router.push({path: "/ModernStack/" + this.uid + "/" + module + "/" + title});
          break;


        case 'ModernDWhite':
        case 'ModernDHigh':
        case 'ModernDSour':
          this.$router.push({path: "/ModernDay/" + this.uid + "/" + module + "/" + title});
          break;
        case 'ModernPWhite':
        case 'ModernPHigh':
        case 'ModernPSour':
          this.$router.push({path: "/ModernPromotion/" + this.uid + "/" + module + "/" + title});
          break;
        case 'ModernNew':
          this.$router.push({path: "/ModernNew/" + this.uid + "/" + module + "/" + title});
          break;
        case 'TwentyAvgGoods':
          this.$router.push({path: "/TwentyAvgGoods/" + this.uid + "/" + module + "/" + title});
          break;
        case 'TwentyBox':
          this.$router.push({path: "/TwentyBox/" + this.uid + "/" + module + "/" + title});
          break;
        case 'TwentyNew':
          this.$router.push({path: "/TwentyNew/" + this.uid + "/" + module + "/" + title});
          break;
        case 'TwentyStock':
          this.$router.push({path: "/TwentyStock/" + this.uid + "/" + module + "/" + title});
          break;
        case 'MAAvgGoods':
          this.$router.push({path: "/MAAvgGoods/" + this.uid + "/" + module + "/" + title});
          break;
        case 'MABox':
          this.$router.push({path: "/MABox/" + this.uid + "/" + module + "/" + title});
          break;
        case 'MANew':
          this.$router.push({path: "/MANew/" + this.uid + "/" + module + "/" + title});
          break;
        case 'MADisplay':
          this.$router.push({path: "/MADisplay/" + this.uid + "/" + module + "/" + title});
          break;
        case 'EightyAvgGoods':
          this.$router.push({path: "/EightyAvgGoods/" + this.uid + "/" + module + "/" + title});
          break;
        case 'EightyGoods':
          this.$router.push({path: "/EightyGoods/" + this.uid + "/" + module + "/" + title});
          break;
        case 'EightyBox':
          this.$router.push({path: "/EightyBox/" + this.uid + "/" + module + "/" + title});
          break;
        case 'AllStock':
          this.$router.push({path: "/AllStock/" + this.uid + "/" + module + "/" + title});
          break;
        case 'AllDisplay':
          this.$router.push({path: "/AllDisplay/" + this.uid + "/" + module + "/" + title});
          break;
        case 'CVSAvg':
          this.$router.push({path: "/CVSAvg/" + this.uid + "/" + module + "/" + title});
          break;
        case 'CVSFreezer':
          this.$router.push({path: "/CVSFreezer/" + this.uid + "/" + module + "/" + title});
          break;
        case 'CVSDisplay':
          this.$router.push({path: "/CVSDisplay/" + this.uid + "/" + module + "/" + title});
          break;
        case 'CVSStock':
          this.$router.push({path: "/CVSStock/" + this.uid + "/" + module + "/" + title});
          break;
      }
    },
    toBack() {
      let flutterMsg = {
        type: 'backPage',
      }
      flutter_h5_method.postMessage(JSON.stringify(flutterMsg));
    },

  }
};
</script>

<style scoped>
@import "../../assets/css/kpi/kpi.css";

.kpiListPage {
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/kpi/KPIList.vue